import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudPHPInterfaces = () => import('./staff/crudPHPInterfaces')
const ViewStaffCrudPHPCron = () => import('./staff/crudPHPCron')
const ViewStaffCrudPHPCallback = () => import('./staff/crudPHPCallback')
const ViewStaffCrudPHPCode = () => import('./staff/crudPHPCode')
const ViewStaffViewPHPCustom = () => import('./staff/viewPHPCustom')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'PHPStaffDashboard',
  crudPHPInterfaces: 'PHPStaffCrudPHPInterfaces',
  crudPHPCron: 'PHPStaffCrudPHPCron',
  crudPHPCallback: 'PHPStaffCrudPHPCallback',
  crudPHPCode: 'PHPStaffCrudPHPCode',
  viewPHPCustom: 'ViewStaffViewPHPCustom',
}

const router =
  [
    {
      path: '/st/php',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'PHP',
          }
        },   
        {
          path: 'interfaces',
          name: VIEWS.crudPHPInterfaces,
          component: ViewStaffCrudPHPInterfaces,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'PHP - Interfaces',
          }
        },
        {
          path: 'cron',
          name: VIEWS.crudPHPCron,
          component: ViewStaffCrudPHPCron,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'PHP - Cron',
          }
        },
        {
          path: 'callback',
          name: VIEWS.crudPHPCallback,
          component: ViewStaffCrudPHPCallback,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'PHP - Callback',
          }
        },        
        {
          path: 'code/:id',
          name: VIEWS.crudPHPCode,
          component: ViewStaffCrudPHPCode,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'PHP - Código Fuente',
          }
        },
        {
          path: 'php-custom/:id',
          name: VIEWS.viewPHPCustom,
          component: ViewStaffViewPHPCustom,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Vista Personalizada',
          }
        }
      ]
    },

    {
      path: '/cu/php',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/php',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
